module.exports = __webpack_public_path__ + "img/btn-success.f6f428ea.gif";